/* ============
 * Getters for the audience transfer module
 * ============
 *
 * The getters that are available on the
 * audience transfer module.
 */

import { getField } from 'vuex-map-fields';

export default {
  // Add the `getField` getter to the
  // `getters` of your Vuex store instance.
  getField,
};
